import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import featureFlags from '../config/featureFlags';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_67b9bb81-7260-44ec-aaa3-ea9719c1ace2/artifacts/fzzdas0u_100915ed-2232-44be-a466-4b016240034b.jpeg";

// Quick links - Shop link is conditionally included based on feature flag
const getQuickLinks = () => {
  const links = [
    { label: 'Start', href: '#start', type: 'scroll' },
    { label: 'Leistungen', href: '#leistungen', type: 'scroll' },
    { label: 'Referenzen', href: '#referenzen', type: 'scroll' },
  ];
  
  if (featureFlags.SHOP_ENABLED) {
    links.push({ label: 'Sticker Shop', href: '#sticker', type: 'scroll' });
  }
  
  links.push(
    { label: 'Über uns', href: '#ueber-uns', type: 'scroll' },
    { label: 'Kontakt', href: '#kontakt', type: 'scroll' }
  );
  
  return links;
};

const legalLinks = [
  { label: 'Impressum', href: '/impressum', type: 'link' },
  { label: 'Datenschutz', href: '/datenschutz', type: 'link' },
  { label: 'Widerrufsrecht', href: '/widerrufsrecht', type: 'link' },
  { label: 'Zahlungsmethoden', href: '/zahlungsmethoden', type: 'link' }
];

export const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer
      className="bg-slate-900 text-white"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#start" onClick={(e) => scrollToSection(e, '#start')} className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="AKW Design"
                className="h-16 w-auto"
              />
            </a>
            <p className="text-slate-400 mb-6 max-w-md">
              AKW Design – Ihr Partner für professionelle Werbetechnik-Designs und druckfertige Folienlösungen aus Weilburg. Kreativität, die man sieht.
            </p>
            <div className="space-y-3">
              <a href="tel:+4915510904109" className="flex items-center gap-3 text-slate-400 hover:text-teal-400 transition-colors">
                <Phone className="w-4 h-4" />
                <span>+49 155 10904109</span>
              </a>
              <a href="mailto:akw-design@gmx.de" className="flex items-center gap-3 text-slate-400 hover:text-teal-400 transition-colors">
                <Mail className="w-4 h-4" />
                <span>akw-design@gmx.de</span>
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-4 h-4" />
                <span>35781 Weilburg</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {getQuickLinks().map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-teal-400 transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">
              Rechtliches
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-teal-400 transition-colors"
                    data-testid={`footer-legal-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">
              © {new Date().getFullYear()} AKW Design. Alle Rechte vorbehalten.
            </p>
            <p className="text-sm text-slate-500">
              Werbetechnik-Design aus Weilburg
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
